import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"min-height":"45vw"}
}
const _hoisted_2 = { class: "content p-4 w-50 mx-auto" }
const _hoisted_3 = { class: "card-title mt-0 mb-4" }
const _hoisted_4 = { class: "d-flex justify-content-end m-3" }

import DisplayDeliveryPlanInformation from '@/components/DailyReportEdit/AlterLeaving/DisplayDeliveryPlanInformation.vue';
import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import RegisterModal from '@/components/DailyReportEdit/AlterLeaving/RegisterModal.vue';
import DatePicker from '@/components/DailyReportEdit/AlterLeaving/DatePicker.vue';
import CompleteModal from '@/components/DailyReportEdit/Split/CompleteModal.vue';
import ValidationErrors from '@/components/Common/ValidationErrors.vue';
import { formatDateTimeWithSeconds } from '@/services/functions';
import { useAuth } from '@/services/user/Auth0UserProvider';
import Api from '@/services/api/ApiServiceFabrick';
import { ref, Ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'AlterLeavingForm',
  props: {
    showFlash: { type: Function },
    deliveryPlan: {}
  },
  setup(__props: any) {

const props = __props;

const { loginWithRedirect } = useAuth();
const router = useRouter();
const isProcessing: Ref<boolean> = ref(false);
const errorMessages = ref<{
  leaving_time: string[]
  delivery_plan_id: string[]
}>({
  leaving_time: [],
  delivery_plan_id: []
});

const leavingDateTime: Ref<Date | null> = ref(props.deliveryPlan.leaving_warehouse_date_time ? new Date(props.deliveryPlan.leaving_warehouse_date_time) : null);
const isLoading: Ref<boolean> = ref(false);
const isOpenDialog: Ref<boolean> = ref(false);
const isDisplayCompleteModal: Ref<boolean> = ref(false);

const isActiveExecBtn = computed(() => {
  return leavingDateTime.value?.getTime() != new Date(props.deliveryPlan.leaving_warehouse_date_time).getTime();
})

const execBtnClass = computed(() => {
  return {
    'exec-btn-disabled': isProcessing.value || !isActiveExecBtn.value
  };
});

function moveDailyReportDisplay() {
  router.push({ name: "DailyReport" })
}

function execAlterLeaving() {
  isLoading.value = true;
  errorMessages.value = {
    leaving_time: [],
    delivery_plan_id: []
  };

  Api().alterLeaving(props.deliveryPlan.delivery_plan_id, makeRequest()).then((data) => {
    if (data.status) {
      return isDisplayCompleteModal.value = true;
    }
    props.showFlash(i18n.global.t('pages.dailyReports.splitForm.failedMessage'), 'error', true);
  }).catch((error) => {
    errorHandler(error);
  }).finally(() => {
    isLoading.value = false;
  });
}

function makeRequest() {
  return {
    leaving_time: leavingDateTime.value ? formatDateTimeWithSeconds(leavingDateTime.value) : ''
  }
}

function errorHandler(error: any) {
  const res = error.response
  switch (res.status) {
    case 401:
      loginWithRedirect({ appState: { targetUrl: location.pathname } })
      break
    case 403:
      location.reload()
      break
    case 422:
      errorMessages.value = res.data.errors
      if (errorMessages.value['delivery_plan_id']?.length) {
        isProcessing.value = true;
      }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_card, { class: "my-4 pa-4" }, {
          default: _withCtx(() => [
            _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.alterLeavingOrReturning.leavingTitle')), 1),
            _createVNode(_component_v_row, { class: "mt-2 mb-4 ml-12" }, {
              default: _withCtx(() => [
                _createVNode(DisplayDeliveryPlanInformation, {
                  deliveryPlan: props.deliveryPlan
                }, null, 8, ["deliveryPlan"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { class: "text-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "4",
                  class: "ml-12"
                }, {
                  default: _withCtx(() => [
                    _createVNode(DatePicker, {
                      modelValue: leavingDateTime.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((leavingDateTime).value = $event)),
                      deliveryPlan: props.deliveryPlan,
                      label: _unref(i18n).global.t('pages.dailyReports.alterLeavingOrReturning.leavingDateTime'),
                      maxDate: props.deliveryPlan.returning_warehouse_date_time,
                      errorMessages: errorMessages.value.leaving_time
                    }, null, 8, ["modelValue", "deliveryPlan", "label", "maxDate", "errorMessages"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_btn, {
                class: "ma-2 reset-btn",
                disabled: isLoading.value,
                onClick: moveDailyReportDisplay
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.cancelBtn')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              _createVNode(_component_v_btn, {
                class: _normalizeClass(["ma-2 exec-btn", execBtnClass.value]),
                loading: isLoading.value,
                disabled: isProcessing.value || !isActiveExecBtn.value,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (isOpenDialog.value = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.confirmBtn')), 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled", "class"])
            ]),
            _createVNode(ValidationErrors, {
              class: "d-flex justify-content-end",
              messages: errorMessages.value.delivery_plan_id
            }, null, 8, ["messages"])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(RegisterModal, {
      title: _unref(i18n).global.t('pages.dailyReports.alterLeavingOrReturning.confirmTitle'),
      modelValue: isOpenDialog.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isOpenDialog).value = $event)),
      message: _unref(i18n).global.t('pages.dailyReports.alterLeavingOrReturning.leavingMessage'),
      changeValues: [
      props.deliveryPlan.leaving_warehouse_date_time,
      _unref(formatDateTimeWithSeconds)(leavingDateTime.value ?? new Date(props.deliveryPlan.leaving_warehouse_date_time))
    ],
      showFlash: props.showFlash,
      execFunction: execAlterLeaving
    }, null, 8, ["title", "modelValue", "message", "changeValues", "showFlash"]),
    _createVNode(CompleteModal, {
      modelValue: isDisplayCompleteModal.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isDisplayCompleteModal).value = $event)),
      messages: [
      _unref(i18n).global.t('pages.dailyReports.alterLeavingCompleteModal.messageRow1'),
      _unref(i18n).global.t('pages.dailyReports.alterLeavingCompleteModal.messageRow2')
    ],
      moveDailyReportDisplay: moveDailyReportDisplay
    }, null, 8, ["modelValue", "messages"])
  ], 64))
}
}

})